// Only what en-GB says differently; every other string is en-US (mergeLocaleResources).
export const work = {
  rules: {
    stopConfirmBody_one: 'Its {{count}} inspection that has not started will be cancelled. Finished inspections stay.',
    stopConfirmBody_other: 'Its {{count}} inspections that have not started will be cancelled. Finished inspections stay.',
  },
} as const;
